module.exports = __webpack_public_path__ + "media/images/logo-5c74775f7e8ae0de348ab15a80fbc624.png";